export default "__VITE_ASSET__Cqfq4M1c__"